import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-registration-title',
  templateUrl: './registration-title.component.html',
  styleUrls: ['./registration-title.component.scss']
})
export class RegistrationTitleComponent {
  @Input() portalRegistrationPageData:any;
  @Input() isLoading!:boolean;
  titleImage: any = null;
}
